import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, message, Row, Col, Typography } from "antd";
import { PhoneOutlined } from "@ant-design/icons";
import useAuth from "../../../../hooks/useAuth";
import { useUser } from "../../../../context/UserContext";
import userService from "../../../../services/UserService";

const { Title, Text } = Typography;

const validatePhone = (_, value) => {
  const regex = /^[+\d]+$/;
  if (value && !regex.test(value)) {
    return Promise.reject(
      new Error("Ingrese solo números y el caracter + en el teléfono")
    );
  }
  return Promise.resolve();
};

const ModalCompletarPerfil = () => {
  const { session, setSession } = useAuth();
  const user = useUser();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const faltaInformacion =
    !!session?.user && (!session.user.name || !session.user.phone);

  useEffect(() => {
    if (faltaInformacion) {
      form.setFieldsValue({
        name: session.user.name,
        lastName: session.user.lastName,
        phone: session.user.phone,
      });
    }
  }, [faltaInformacion, session?.user, form]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await userService.EditarUsusairo(session.user.id, values, user.idToken);
      setSession((prev) => ({ ...prev, user: { ...prev.user, ...values } }));
      message.success("Información personal actualizada correctamente");
    } catch (error) {
      console.error("Error al actualizar la información personal:", error);
      message.error("No se logró actualizar la información personal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={faltaInformacion}
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      destroyOnClose
      width={440}
    >
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            background: "rgba(122, 193, 66, 0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
          }}
        >
          <PhoneOutlined style={{ fontSize: 22, color: "#7AC142" }} />
        </div>
        <Title level={4} style={{ margin: 0 }}>
          Completemos tu perfil
        </Title>
        <Text type="secondary" style={{ fontSize: 13 }}>
          En una emergencia necesitamos poder ubicarte. Registra tu nombre y
          tu teléfono para continuar.
        </Text>
      </div>

      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Row gutter={12}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="name"
              label="Nombre"
              rules={[
                { required: true, message: "Por favor ingrese el nombre" },
              ]}
            >
              <Input placeholder="Tu nombre" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="lastName"
              label="Apellido"
              rules={[
                { required: true, message: "Por favor ingrese el apellido" },
              ]}
            >
              <Input placeholder="Tu apellido" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="phone"
          label="Teléfono"
          extra="Solo lo usaremos para contactarte durante una emergencia operativa."
          rules={[
            { required: true, message: "Por favor ingrese el teléfono" },
            { validator: validatePhone },
          ]}
        >
          <Input placeholder="Ej. +573001234567" />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          block
          style={{ marginTop: 8 }}
        >
          Guardar y continuar
        </Button>
      </Form>
    </Modal>
  );
};

export default ModalCompletarPerfil;
